/**
 * Created by tofael on 9/4/18.
 */
import React from 'react';
import LeftIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-left';
import RightIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-right';
import {typography} from 'material-ui/styles';
import IconButton from 'material-ui/IconButton';

const styles = {
  navigation: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 5
  },
  label:{
    padding: 12,
    fontSize: 18,
    fontWeight: typography.fontWeightNormal,
  }
};

const PdfNavigator = ({pageNumber, numPages, onNext, onPrevious}) => {
  return (
    <div style={styles.navigation}>
      <IconButton
        disabled={pageNumber <= 1}
        onTouchTap={onPrevious}>
        <LeftIcon/>
      </IconButton>
      <span style={styles.label}> Page {pageNumber} of {numPages} </span>
      <IconButton
        disabled={pageNumber >= numPages}
        onTouchTap={onNext}>
        <RightIcon/>
      </IconButton>
    </div>
  );
};

export default PdfNavigator;


// WEBPACK FOOTER //
// ./src/screens/shared/file-upload/preview/pdf-navigatior.js